/*
* Created on Mar 30, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React from 'react';
import logo_facebook from "../../static/img/utils/logo_facebook_white.svg";
import logo_twitter from "../../static/img/utils/logo_twitter_white.svg";
import logo_youtube from "../../static/img/utils/logo_youtube_white.svg";
import logo_sina_webo from "../../static/img/utils/logo_sina_weibo.svg";
import Youku from "../../static/img/utils/logo_youku.svgz";
import china_jin_svg from "../../static/img/utils/china_jin_icon.png";
import {useRegion} from "../../context/RegionContext";
import {useTranslation} from "react-i18next";
import {convertToQNAPLang} from "../../service/common";

const MainFooterComponent = ({setShowFooter}) => {
    const {region, url} = useRegion();
    const cur_year = new Date().getFullYear();
    const {t, i18n} = useTranslation();

    return (
        <div className="footer">
            {/*// <!-- 相關連結位置 -->*/}
            <div className="footer-utils">
                <div className="footer-links">
                    <span className="link-item"><a href={`${url.get_qnap_url()}/${convertToQNAPLang(i18n.language)}`} target="_blank">{t('@About us@')}</a></span>
                    <span className="link-item"><a href={`${url.get_qnap_url()}/${region === 'CHINA' ? 'zh-cn' : 'go'}/legal/qnap-privacy-policy`} target="_blank">{t('@Privacy policy@')}</a></span>
                    <span className="link-item"><a href={`${url.get_qnap_url()}/${convertToQNAPLang(i18n.language)}/before_buy/con_show.php?op=showone&cid=15`} target="_blank">{t('@Terms of service@')}</a></span>
                    <span className="link-item"><a href={`${url.get_qnap_url()}/${convertToQNAPLang(i18n.language)}/support-ticket/`} target="_blank">{t('@Contact us@')}</a></span>
                    { region !== 'CHINA' && <span className="link-item"><a href={`${window._env_.REACT_APP_FORUM_URL}`} target="_blank">{t('@Forum@')}</a></span>}
                    <span className="link-item"><a href={`${url.get_cms_url()}/security?lang=${i18n.language}`} target="_blank">{t('@Security Disclaimer@')}</a></span>
                </div>
                <div className="footer-sns">
                    {
                        region !== 'CHINA' &&
                        <>
                            <span className="sns-item facebook"><a href="https://www.facebook.com/QNAPSys" rel="noreferrer" target="_blank"><img src={logo_facebook} alt=""/></a></span>
                            <span className="sns-item twitter"><a href="https://twitter.com/QNAP_nas" rel="noreferrer" target="_blank"><img src={logo_twitter} alt=""/></a></span>
                            <span className="sns-item youtube"><a href="https://www.youtube.com/user/qnapsys" rel="noreferrer" target="_blank"><img src={logo_youtube} alt=""/></a></span>
                        </>
                    }

                    {/*// <!-- 微博、優酷，只在中國顯示 -->*/}
                    {
                        region === 'CHINA' &&
                        <>
                            <span className="sns-item weibo"><a href="https://www.weibo.com/qnap?is_hot=1" target="_blank"><img src={logo_sina_webo} alt=""/></a></span>
                            <span className="sns-item youku"><a href="https://i.youku.com/i/UMzE3MDAwNzUyNA==/videos?spm=a2hzp.8244740.0.0" target="_blank">
                                <img src={Youku} alt="" />
                            </a></span>
                        </>
                    }
                </div>
            </div>
            <div className="footer-copyright">
                {region !== 'CHINA' && <div>{t('@Copyright {year}; QNAP Systems, Inc. All Rights Reserved.@', {interpolation: {prefix: "{", suffix: "}"}, year: cur_year})}</div>}
                {/*// <!-- 中國備案號位置，只在中國顯示 -->*/}
                {region === 'CHINA' &&
                    <>
                    <div>威博通科技（上海）有限公司 &copy;{cur_year} 版权所有</div>
                    <div className="china_site">
                        <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2022006091号-2</a>
                        |
                        <img className="!mr-4" src={china_jin_svg} alt=""/>
                        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025528" target="_blank">京公网安备11010802025528号</a>
                    </div>
                    </>
                }
            </div>
        </div>
    );
};

export default MainFooterComponent;